import { render, staticRenderFns } from "./JeanneQuinn.vue?vue&type=template&id=61db52b6&"
import script from "./JeanneQuinn.vue?vue&type=script&lang=js&"
export * from "./JeanneQuinn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports